import React from 'react';
import LoaderChord from './LoaderChord';
import styles from './styles.module.css';

const Loader = () => (
  <div className={styles.component}>
    <div className={styles.loadingMsg}>
      loading
    </div>

    <div className={`${styles.loaderChord} animate__animated animate__fadeIn`}>
      <LoaderChord />
    </div>
  </div>
);

export default Loader;
